<script>
import {
  ArrowUpIcon,
  FacebookIcon,
  InstagramIcon,
  TwitterIcon,
  LinkedinIcon,
  GithubIcon,
  YoutubeIcon,
  GitlabIcon,
  MailIcon,
  UserPlusIcon,
  UsersIcon,
  MessageCircleIcon,
  BellIcon,
  ToolIcon,
  UserIcon,
  KeyIcon,
  PhoneIcon,
  BookmarkIcon,
  UserCheckIcon,
  GlobeIcon,
} from "vue-feather-icons";
import countTo from 'vue-count-to';
import appConfig from "@/app.config";
import axios from 'axios';

// 초기세팅
function initialState() {
  return {
    token: "",
    login: {
      idx: 0,
      level: 0,
      nick: "",
      isLogin: false,
    },
    modifyInfo: {
      board: {}
    }
  };
}

export default {
  components: {
    ArrowUpIcon,
    FacebookIcon,
    TwitterIcon,
    LinkedinIcon,
    GithubIcon,
    YoutubeIcon,
    GitlabIcon,
    InstagramIcon,
    MailIcon,
    UserPlusIcon,
    UsersIcon,
    BellIcon,
    ToolIcon,
    UserIcon,
    KeyIcon,
    PhoneIcon,
    BookmarkIcon,
    MessageCircleIcon,
    UserCheckIcon,
    GlobeIcon,
    countTo,
  },
  data() {
    return initialState();
  },
  props: {
    selectedMenu: {
      type: String,
    },
  },
  computed: {
  },
  mounted() {
  },
  created() {
    this.first()
    this.getWebSiteInfoBase()
  },
  methods: {
    first() {
      let getLocalStorage = JSON.parse(localStorage.getItem('user'))
      if (getLocalStorage) {
        this.login.idx = getLocalStorage.idx
        this.login.nick = getLocalStorage.nick
        this.login.level = getLocalStorage.level
        this.token = getLocalStorage.token
        // 레벨 98 이하거나 로그인 안한상태면 첫화면으로
        if (this.login.level < 98) {
          this.$notify({ type: 'error', duration: 2000, title: '실패', text: '관리자 권한이 없습니다.' })
          this.$router.push('/');
        } else {
          this.r_admin_basicinfo()
        }
      } else {
        this.$notify({ type: 'error', duration: 2000, title: '실패', text: '관리자 권한이 없습니다.' })
        this.$router.push('/');
      }
    },
    // 홈페이지 기본정보
    getWebSiteInfoBase() {
      this.baseInfo = this.$store.getters.getWebSiteInfoBase
    },
    // 관리페이지 기본설정
    async r_admin_basicinfo() {
      try {
        this.loadingBar(true)
        await axios({
          method: 'POST',
          url: appConfig.fastapi + '/auth/r_admin_basicinfo',
          headers: {
            'access-token': this.token
          },
          data: {
            "mb_idx": this.login.idx,
            "mb_level": this.login.level,
          },
        })
        .then((res) => {
          if (res.data) {
            if (res.data.boardData) {
              this.modifyInfo.board = res.data.boardData
            }
          }
        })
        .catch((error) => {
          console.log(error)
          if (error.response) {
            this.$notify({ type: 'error', duration: 3000, 'title': error.response.status+' 에러', text: error.response.data.detail })
          }
        })
      } catch (error) {
        this.$notify({ type: 'error', duration: 3000, title: '실패', text: '요청 중 에러 발생 관리자에게 문의4'+error })
      } finally {
        this.loadingBar(false)
      }
    },
    sendModifyBoardData(value) {
      if (value.idx !=='' && value.contents.group !=='' && 
      value.contents.group_priority !=='' && value.contents.lv_reply !=='' &&
      value.contents.lv_see !=='' && value.contents.lv_write !=='' && 
      value.contents.name !=='' && value.contents.text !=='' &&
      value.contents.use_notice !=='' && value.contents.use_secret !=='' && value.contents.use_latest !=='') {
        this.m_boarddata_modify(value)
      } else {
        this.$notify({ type: 'error', duration: 2000, title: '실패', text: '모든 칸을 채워주세요' })
      }
    },
    async m_boarddata_modify(value) {
      try {
        this.loadingBar(true)
        if (value) {
          await axios({
            method: 'POST',
            url: appConfig.fastapi + '/auth/m_boarddata_modify',
            headers: {
              'access-token': this.token
            },
            data: {
              "idx": value.idx,
              "contents": value.contents,
            },
          })
          .then((res) => {
            if (res.data.type == 'success') {
              this.$notify({ type: 'success', duration: 3000, title: '성공', text: '저장되었습니다.' })
            } else {
              this.$notify({ type: 'error', duration: 3000, 'title': res.data.status+' 에러', text: res.data.detail })
            }
          })
          .catch((error) => {
            console.log(error)
            if (error.response) {
              this.$notify({ type: 'error', duration: 3000, 'title': error.response.status+' 에러', text: error.response.data.detail })
            }
          })
          .finally(()=> {
            // 
          })
        }
      } catch (error) {
        this.$notify({ type: 'error', duration: 3000, title: '실패', text: '요청 중 에러 발생 관리자에게 문의'+error })
      } finally {
        this.loadingBar(false)
      }
    },
    // 기다려주세요 loading 처리
    loadingBar(val) {
      this.$nextTick(() => {
        const preloader = document.getElementById("preloader");
        const status = document.getElementById("status");
        
        if (preloader && status) {
          if (val === true) {
            preloader.style.display = "block";
            status.style.display = "block";
          } else {
            preloader.style.display = "none";
            status.style.display = "none";
          }
        }
      });
    },
  },
}
</script>

<template>
  <div v-show="modifyInfo">
    <div class="rounded shadow">
      <div id="loading-area" class="p-4 border-bottom">
        <h5 class="text-md-left text-center">게시판 설정</h5>
        <div>

          <!-- 게시판 그룹별 -->
          <div v-if="modifyInfo.board" class="">
            <div v-for="(item, index) in modifyInfo.board" :key="index" class="p-1">
              <div v-for="(i, ind) in item" :key="ind" class="card p-3 mb-1 admin-board-list position-relative">
                
                
                <ul class="label list-unstyled mb-0">
                  <li>
                    <a href="javascript:void(0)" class="badge badge-secondary">{{ i.contents.name }}</a>
                  </li>
                </ul>

                <div class="card-body">
                  <div class="row">

                    <!-- 게시판 이름 -->
                    <div class="col-xl-4 col-md-12 col-sm-12">
                      <div class="form-group">
                        <label for="board_name" class="admin-label">
                          <li class="list-inline-item">
                            <a href="javascript:void(0)" class="text-secondary" v-b-tooltip.hover title="게시판의 이름을 적어주세요">
                              게시판 이름
                              <i class="mdi mdi-comment-question"></i>
                            </a>
                          </li>
                        </label>
                        <div class="position-relative">
                          <input v-model="i.contents.name" name="board_name" id="board_name" type="text" class="form-control text-bold text-dark" placeholder=""/>
                        </div>
                      </div>
                    </div>
                    <!-- 상단 문구 -->
                    <div class="col-xl-8 col-md-12 col-sm-12">
                      <div class="form-group">
                        <label for="board_text" class="admin-label">
                          <li class="list-inline-item">
                            <a href="javascript:void(0)" class="text-secondary" v-b-tooltip.hover title="게시판 상단에 나올 텍스트를 적어주세요">
                              상단 문구
                              <i class="mdi mdi-comment-question"></i>
                            </a>
                          </li>
                        </label>
                        <div class="position-relative">
                          <input v-model="i.contents.text" name="board_text" id="board_text" type="text" class="form-control text-bold text-dark" placeholder=""/>
                        </div>
                      </div>
                    </div>
                    <!-- 리스트 개수 -->
                    <div class="col-xl-2 col-md-6 col-sm-6 ">
                      <div class="form-group">
                        <label for="board_listnum" class="admin-label">
                          <li class="list-inline-item">
                            <a href="javascript:void(0)" class="text-secondary" v-b-tooltip.hover 
                            title="게시물 리스트의 한 페이지당 게시글이 몇 개의 글이 노출되게 할지 정해주세요">
                              리스트 개수
                              <i class="mdi mdi-comment-question"></i>
                            </a>
                          </li>
                        </label>
                        <div class="position-relative">
                          <input v-model.number="i.contents.listnum" name="board_listnum" id="board_listnum" type="number" 
                          class="form-control text-bold text-dark" placeholder=""/>
                        </div>
                      </div>
                    </div>
                    <!-- 카테고리 -->
                    <div class="col-xl-2 col-md-6 col-sm-6">
                      <div class="form-group">
                        <label for="board_group" class="admin-label">
                          <li class="list-inline-item">
                            <a href="javascript:void(0)" class="text-secondary" v-b-tooltip.hover title="게시판 진입 후 같이 묶을 카테고리의 번호를 선택해주세요 (같은 숫자끼리 묶입니다)">
                              카테고리
                              <i class="mdi mdi-comment-question"></i>
                            </a>
                          </li>
                        </label>
                        <div class="position-relative">
                          <input v-model.number="i.contents.group" name="board_group" id="board_group" type="number" class="form-control text-bold text-dark" placeholder=""/>
                        </div>
                      </div>
                    </div>
                    <!-- 노출 순서 -->
                    <div class="col-xl-2 col-md-6 col-sm-6">
                      <div class="form-group">
                        <label for="board_group_priority" class="admin-label">
                          <li class="list-inline-item">
                            <a href="javascript:void(0)" class="text-secondary" v-b-tooltip.hover title="같은 카테고리 게시판들 중에 목록에 나올 순서를 정합니다.">
                              노출 순서
                              <i class="mdi mdi-comment-question"></i>
                            </a>
                          </li>
                        </label>
                        <div class="position-relative">
                          <input v-model.number="i.contents.group_priority" name="board_group_priority" id="board_group_priority" type="number" 
                          class="form-control text-bold text-dark" placeholder=""/>
                        </div>
                      </div>
                    </div>
                    
                    <!-- 읽기 권한 -->
                    <div class="col-xl-2 col-md-6 col-sm-6 ">
                      <div class="form-group">
                        <label for="board_lv_see" class="admin-label">
                          <li class="list-inline-item">
                            <a href="javascript:void(0)" class="text-secondary" v-b-tooltip.hover 
                            title="읽기 권한 0 이면 모든사람이 다 읽을 수 있어요 98 이면 일반관리자, 99 라면 최고관리자만 읽을 수 있어요">
                              읽기 권한
                              <i class="mdi mdi-comment-question"></i>
                            </a>
                          </li>
                        </label>
                        <div class="position-relative">
                          <input v-model.number="i.contents.lv_see" name="board_lv_see" id="board_lv_see" type="number" 
                          class="form-control text-bold text-dark" placeholder=""/>
                        </div>
                      </div>
                    </div>
                    <!-- 쓰기 권한 -->
                    <div class="col-xl-2 col-md-6 col-sm-6 ">
                      <div class="form-group">
                        <label for="board_lv_write" class="admin-label">
                          <li class="list-inline-item">
                            <a href="javascript:void(0)" class="text-secondary" v-b-tooltip.hover 
                            title="쓰기 권한 0 이면 모든사람이 다 쓸 수 있어요 98 이면 일반관리자 이상, 99 라면 최고관리자만 글 쓰기가 가능해요">
                              쓰기 권한
                              <i class="mdi mdi-comment-question"></i>
                            </a>
                          </li>
                        </label>
                        <div class="position-relative">
                          <input v-model.number="i.contents.lv_write" name="board_lv_write" id="board_lv_write" type="number" 
                          class="form-control text-bold text-dark" placeholder=""/>
                        </div>
                      </div>
                    </div>
                    <!-- 답변 권한 -->
                    <div class="col-xl-2 col-md-6 col-sm-6 ">
                      <div class="form-group">
                        <label for="board_lv_reply" class="admin-label">
                          <li class="list-inline-item">
                            <a href="javascript:void(0)" class="text-secondary" v-b-tooltip.hover 
                            title="답변 권한 0 이면 모든사람이 다 답변글 작성할 수 있어요 98 이면 일반관리자 이상, 99 라면 최고관리자만 답변글 쓰기가 가능해요">
                              답변 권한
                              <i class="mdi mdi-comment-question"></i>
                            </a>
                          </li>
                        </label>
                        <div class="position-relative">
                          <input v-model.number="i.contents.lv_reply" name="board_lv_reply" id="board_lv_reply" type="number" 
                          class="form-control text-bold text-dark" placeholder=""/>
                        </div>
                      </div>
                    </div>
                    <!-- 게시물 상단고정 -->
                    <div class="col-xl-2 col-md-6 col-sm-6 ">
                      <div class="form-group">
                        <label for="board_use_notice" class="admin-label">
                          <li class="list-inline-item">
                            <a href="javascript:void(0)" class="text-secondary" v-b-tooltip.hover 
                            title="공지글처럼 게시판 목록에서 제일 상단에 고정시키는 기능을 사용할 지 정해주세요">
                              상단고정 사용
                              <i class="mdi mdi-comment-question"></i>
                            </a>
                          </li>
                        </label>
                        <select v-model="i.contents.use_notice" id="board_use_notice" class="form-control custom-select">
                          <option :value="true">사용함</option>
                          <option :value="false">사용안함</option>
                        </select>
                      </div>
                    </div>
                    <!-- 게시물 전체비밀글 -->
                    <div class="col-xl-2 col-md-6 col-sm-6 ">
                      <div class="form-group">
                        <label for="board_use_secret" class="admin-label">
                          <li class="list-inline-item">
                            <a href="javascript:void(0)" class="text-secondary" v-b-tooltip.hover 
                            title="작성된 모든 글을 비밀글로 만드는 기능입니다.">
                              전체비밀글
                              <i class="mdi mdi-comment-question"></i>
                            </a>
                          </li>
                        </label>
                        <select v-model="i.contents.use_secret" id="board_use_secret" class="form-control custom-select">
                          <option :value="true">사용함</option>
                          <option :value="false">사용안함</option>
                        </select>
                      </div>
                    </div>
                    <!-- 최근게시물 노출 -->
                    <div class="col-xl-2 col-md-6 col-sm-6 ">
                      <div class="form-group">
                        <label for="board_use_latest" class="admin-label">
                          <li class="list-inline-item">
                            <a href="javascript:void(0)" class="text-secondary" v-b-tooltip.hover title="게시판 우측에 최근게시물 사용할지 정하는데 비밀글 게시판은 사용안해야됨">
                              최근글 노출
                              <i class="mdi mdi-comment-question"></i>
                            </a>
                          </li>
                        </label>
                        <select v-model="i.contents.use_latest" id="board_use_latest" class="form-control custom-select">
                          <option :value="true">사용함</option>
                          <option :value="false">사용안함</option>
                        </select>
                      </div>
                    </div>
                    <!-- 리스트 노출타입 -->
                    <div class="col-xl-2 col-md-6 col-sm-6 ">
                      <div class="form-group">
                        <label for="board_listtype" class="admin-label">
                          <li class="list-inline-item">
                            <a href="javascript:void(0)" class="text-secondary" v-b-tooltip.hover title="리스트 타입을 이미지 형식일지 텍스트 형식일지 정해주세요">
                              노출타입
                              <i class="mdi mdi-comment-question"></i>
                            </a>
                          </li>
                        </label>
                        <select v-model="i.contents.listtype" id="board_listtype" class="form-control custom-select">
                          <option :value="'image'">이미지</option>
                          <option :value="'text'">텍스트</option>
                        </select>
                      </div>
                    </div>
                    <!-- 알통 기능 -->
                    <div class="col-xl-2 col-md-6 col-sm-6 ">
                      <div class="form-group">
                        <label for="board_use_altong" class="admin-label">
                          <li class="list-inline-item">
                            <a href="javascript:void(0)" class="text-secondary" v-b-tooltip.hover 
                            title="알통 기능을 사용해서 메일링전송이나 알통 전용 글쓰기 기능 사용유무입니다.">
                              알통 기능
                              <i class="mdi mdi-comment-question"></i>
                            </a>
                          </li>
                        </label>
                        <select v-model="i.contents.use_altong" id="board_use_altong" class="form-control custom-select">
                          <option :value="true">사용함</option>
                          <option :value="false">사용안함</option>
                        </select>
                      </div>
                    </div>
                    
                    <div v-if="login.level == 99" class="col-xl-12">
                      <button class="btn btn-lg btn-block btn-blue" @click="sendModifyBoardData(i)">변경사항 저장하기</button>
                    </div>
                    <div v-else class="col-xl-12">
                      <button class="btn btn-lg btn-block btn-blue" disabled>최고관리자만 저장가능합니다.</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>


        </div>
      </div>
    </div>
    
  </div>
</template>